import { connect } from "react-redux";
import EditItemField from "./EditItemField"
import { submitFormError, clearFormErrors} from "../../../../../redux/actions/wi_actions"

const mapStateToProps = (state) => {
    return ({
        errors: state.errors.wi
    });
}

const mapDispatchToProps = (dispatch) => {
    return ({
        submitFormError: (error) => dispatch(submitFormError(error)),
        clearFormErrors: () => dispatch(clearFormErrors()),
    });
}

export default connect(mapStateToProps, mapDispatchToProps)(EditItemField);